module.exports = __webpack_public_path__ + "img/2.f2ae7a5a.jpg";